import { render, staticRenderFns } from "./ServiceScope.vue?vue&type=template&id=6badbd3b&scoped=true&slot-scope=scope&"
import script from "./ServiceScope.vue?vue&type=script&lang=js&"
export * from "./ServiceScope.vue?vue&type=script&lang=js&"
import style0 from "./ServiceScope.vue?vue&type=style&index=0&id=6badbd3b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6badbd3b",
  null
  
)

export default component.exports